import { render, staticRenderFns } from "./AdminSurveyTemplateEdit.vue?vue&type=template&id=6a7b1774&scoped=true"
import script from "./AdminSurveyTemplateEdit.vue?vue&type=script&lang=js"
export * from "./AdminSurveyTemplateEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7b1774",
  null
  
)

export default component.exports